import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { cn } from '~/utils/common';

export type AlertProps = {
  status?: 'info' | 'success' | 'warning' | 'error';
  icon?: ReactNode;
} & ComponentPropsWithoutRef<'div'>;

export function Alert({
  status,
  icon,
  children,
  className,
  ...divProps
}: AlertProps) {
  return (
    <div
      {...divProps}
      role="alert"
      className={cn(
        'alert',
        {
          'alert-info text-info-content': status === 'info',
          'alert-success text-success-content': status === 'success',
          'alert-warning text-warning-content': status === 'warning',
          'alert-error text-error-content': status === 'error',
        },
        className,
      )}
    >
      {icon && <div>{icon}</div>}
      {children}
    </div>
  );
}
